import {
  Box,
  Form,
  Text,
  WizardStep,
  WizardStepRenderParams,
  useOnNext,
} from '@factorialco/deprecated-design-system'

import SelectField from 'modules/core/components/SelectField'
import TextArea from 'modules/core/components/TextArea'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import {
  WizardData,
  WizardDataField,
  validateMandatoryFIels,
} from 'modules/finance/lib/newBudgetWizard'

const BasicDetailsStep = ({ data, onDataChanged }: WizardStepRenderParams<WizardData>) => {
  const legalEntityOptions = data.legalEntities.map((legalEntity) => ({
    value: legalEntity.id,
    label: legalEntity.legalName ?? '',
  }))

  const handleNext = async () => {
    const mandatoryFields: WizardDataField[] = ['name', 'legalEntityId']

    const { invalidFields, dataWithErrors } = validateMandatoryFIels(mandatoryFields, data)

    onDataChanged(dataWithErrors)

    if (invalidFields.length) {
      return Promise.reject()
    }
  }
  useOnNext(handleNext)
  return (
    <Box gap="s40" flexDirection="column">
      <Box gap="s24" width="full">
        <Box gap="s8">
          <Text.Header2>{i18n.t('budgets.forms.new_budget.basic_information.title')}</Text.Header2>

          <Text.Normal>
            {i18n.t('budgets.forms.new_budget.basic_information.description')}
          </Text.Normal>
        </Box>
      </Box>
      <Box gap="s40" maxWidth="s600">
        <Form padding="s0" notRounded>
          {data.legalEntities.length > 1 && (
            <SelectField
              mandatory
              value={data.legalEntityId + ''}
              label={i18n.t('budgets.forms.new_budget.basic_information.legal_entity')}
              options={legalEntityOptions}
              error={data.errors?.legal_entity_id}
              onChange={(value) =>
                onDataChanged({
                  ...data,
                  legalEntityId: Number(value),
                  currency:
                    data.legalEntities.find((le) => le.id === Number(value))?.currency ?? '',
                })
              }
            />
          )}

          <TextField
            label={i18n.t('budgets.forms.new_budget.basic_information.budget_title')}
            onChange={(value) => onDataChanged({ ...data, name: value })}
            placeholder={i18n.t(
              'budgets.forms.new_budget.basic_information.budget_title_placeholder'
            )}
            value={data.name}
            mandatory
            error={data.errors?.name}
          />

          <TextArea
            label={i18n.t('budgets.forms.new_budget.basic_information.budget_description')}
            onChange={(value) => onDataChanged({ ...data, description: value })}
            placeholder={i18n.t(
              'budgets.forms.new_budget.basic_information.budget_description_placeholder'
            )}
            value={data.description}
            error={data.errors?.description}
          />
        </Form>
      </Box>
    </Box>
  )
}

export const basicDetailsStep = (): WizardStep<WizardData> => ({
  title: i18n.t('budgets.forms.new_budget.basic_information.title'),
  nextText: i18n.t('common.next'),
  render: (props) => <BasicDetailsStep {...props} />,
  isCompleted: () => true,
})
